var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Studio-Final",
    transform: "translate(-360 -500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(151 478.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(25 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M194.16-10.639a21.586,21.586,0,0,1-.24,3.451,10.055,10.055,0,0,1-.26,1.064,1.9,1.9,0,0,1-.81.905,2,2,0,0,1-.91.219,4,4,0,0,1-.95-.242l-.25-.094a22.281,22.281,0,0,1-5.89-4.024l-.09-.09-.38-.42a1.831,1.831,0,0,1-.38-1.138,1.778,1.778,0,0,1,.35-1.064,3.673,3.673,0,0,1,.28-.334l.38-.4a22.445,22.445,0,0,1,5.59-3.789A4.994,4.994,0,0,1,191.94-17H192a1.819,1.819,0,0,1,1.6.991,4.1,4.1,0,0,1,.24.784l.11.544a27.4,27.4,0,0,1,.21,3.688ZM202-11a1.507,1.507,0,0,1-1.5,1.517l-3.7-.327A1.186,1.186,0,0,1,195.62-11a1.186,1.186,0,0,1,1.18-1.191l3.7-.327A1.508,1.508,0,0,1,202-11Z",
    transform: "translate(386) rotate(180)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submitIcon.91905515b4f71aee6e97a6e9eb98e84d.svg";
export { ForwardRef as ReactComponent };